<template>
    <el-config-provider :locale="locale">
        <router-view></router-view>
    </el-config-provider>
</template>

<script>
import {onMounted, onBeforeUnmount} from 'vue';
import {getInfo} from '@/request/api';
import {useRoute} from 'vue-router';
import {LOGIN} from '@/enmus/PageNames';
import {useStore} from 'vuex';
import {AccountTypes} from './enmus/UserType';
import {getPagePath} from '@/router/routerUtil';
import {Vue, Options, setup} from 'vue-class-component';
import {messageToLoginPageWaitFor3S} from '@/util/util';
import {ElConfigProvider} from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn';

@Options({
    name: 'App',
    components: {
        ElConfigProvider
    }
})
export default class App extends Vue {
    locale = zhCn;
    accessCheck = setup(() => {
        const store = useStore();
        const route = useRoute();
        const checkUserAccess = () => {
            if (document.visibilityState === 'hidden') {
                return;
            }
            if (route.name === LOGIN) {
                return;
            }
            const navigaToLogin = () => window.location.href = getPagePath(LOGIN);
            getInfo().then(response => {
                const curUser = response.data;
                const user = store.state.user;
                // 登录账号发生变化
                if (user && curUser) {
                    if (user.accountType === curUser.accountType) {
                        if (
                            user.accountType === AccountTypes.PASSPORT &&
                            user.accountName === curUser.accountName ||
                            user.accountType === AccountTypes.UUAP &&
                            user.uuap === curUser.uuap
                        ) {
                            if (user.userType !== curUser.userType) {
                                // 未被分配用户角色 = 未通过审核, 目标页面为内部页，redirect to login
                                messageToLoginPageWaitFor3S();
                                return;
                            }
                            return;
                        }
                        navigaToLogin();
                    }
                    navigaToLogin();
                } else {
                    navigaToLogin();
                }
            });
        };

        onMounted(() => {
            document.addEventListener('visibilitychange', checkUserAccess, false);
        });

        onBeforeUnmount(() => {
            document.removeEventListener('visibilitychange', checkUserAccess);
        });
        return {};
    });
};
</script>